/**
 * 用来处理防抖函数的 Hook
 * doc: https://ahooks.js.org/zh-CN/hooks/use-debounce-fn/
 */

import debounce from 'lodash/debounce';
import { useEffect, useRef, useMemo } from 'react';

function useDebounceFn(fn, options) {
  const fnRef = useRef(fn);

  const wait = options?.wait ?? 1000;

  const debounced = useMemo(
    () =>
      debounce(
        (...args) => {
          return fnRef.current(...args);
        },
        wait,
        options,
      ),
    [],
  );

  useEffect(() => {
    return () => {
      debounced.cancel();
    };
  }, []);

  return {
    run: debounced,
    cancel: debounced.cancel,
    flush: debounced.flush,
  };
}

export default useDebounceFn;
